export enum Theme {
  LIGHT = 'light'
}
